import React, { useEffect, useState } from 'react';
import { Frame, Heading, Box, Typography, CardList } from 'components';
import { getActiveCareerOppPosts, getDecoratedCareerOppPosts } from 'utils';
import CareerDevCard from 'components/freelancer/CareerDevCard';
import { CareerDevFilterBar, filterInitialState } from 'components/FilterBar/CareerDevFilterBar';
import { isAfter } from 'date-fns';
import {
  useQueryParams,
  withDefault,
  DateParam,
  ArrayParam,
  StringParam,
} from 'use-query-params';

const FreelancerCareerDev = (props) => {
  const [filterState, setFilterState] = useQueryParams({
    id: StringParam,
    date1: withDefault(DateParam, filterInitialState.date1),
    date2: withDefault(DateParam, filterInitialState.date2),
    cities: withDefault(ArrayParam, filterInitialState.cities),
    roles: withDefault(ArrayParam, filterInitialState.roles),
    location: withDefault(StringParam, filterInitialState.location),
  });

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!props.markets) return;
    
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const activePosts = await getActiveCareerOppPosts();
        const decoratedPosts = await getDecoratedCareerOppPosts(props.markets, activePosts);
        setPosts(decoratedPosts);
      } catch (error) {
        console.error('Error fetching career development posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [props.markets]);

  const { date1, roles, cities, location } = filterState;

  const filteredPosts = posts
    .filter((p) => {
      if (filterState.id) return p.id === filterState.id;
      
      // Date filter
      const dateState = date1
        ? isAfter(p.endDate?.toDate(), date1)
        : isAfter(p.endDate?.toDate(), new Date());
      
      // Role filter
      const roleState = roles.length > 0 ? 
        (p.roleId === 'any' || roles.includes(p.roleId)) : true;
      
      // City filter
      const cityState = cities.length > 0 ? cities.includes(p.cityId) : true;
      
      // Location/format filter
      const locationState = location ? p.location === location : true;
      
      return dateState && roleState && cityState && locationState;
    })
    .sort((a, b) => a.trainingType?.localeCompare(b.trainingType));

  return (
    <Frame maxWidth="lg" user={props.user}>
      <Heading>Career Development Opportunities</Heading>
      
      <Box mb={2}>
        <CareerDevFilterBar
          markets={props.markets}
          filterState={filterState}
          setFilterState={setFilterState}
        />
      </Box>
      
      {loading ? (
        <Typography align="center">Loading opportunities...</Typography>
      ) : filteredPosts.length === 0 ? (
        <Typography align="center">
          No career development opportunities found. Try adjusting your filters.
        </Typography>
      ) : (
        <CardList
          cards={filteredPosts.map((post) => (
            <CareerDevCard key={post.id} careerDevPost={post} />
          ))}
        />
      )}
    </Frame>
  );
};

export default FreelancerCareerDev;
